<template>
  <div v-if="to" class="flex flex-col items-center mt-100 lg:mt-130">
    <NuxtLink
      class="btn is-outline cursor-pointer text-2xl px-40"
      :to="to"
      replace
    >
      {{ $texts('loadMoreButtonText', 'Load More') }}
    </NuxtLink>

    <div class="mt-20 font-bold uppercase">
      {{ visible }}
      {{ $texts('loadMoreFromText', 'from') }}
      {{ total }}
    </div>
  </div>
</template>

<script lang="ts" setup>
/**
 * Provides a component to render a link for page based "load more" functionality.
 *
 * Using the provided props a link is rendered to "go to the next page" if one
 * is available. The link triggers a route replace (instead of a push) so going
 * back -1 in the history will not "unload more", but actually go back to the
 * previous page.
 */
const props = defineProps<{
  /**
   * Results per page.
   */
  perPage: number
  page: number
  total: number
}>()

const route = useRoute()

const to = computed(() => {
  // The amount of visible items.
  const visible = (props.page + 1) * props.perPage

  // Return a link if more items can be loaded.
  if (visible < props.total) {
    return {
      query: {
        ...route.query,
        page: props.page + 1,
      },
    }
  }

  return null
})

const visible = computed(() => props.perPage * (props.page + 1))
</script>
